var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 295.239 295.239",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M280.953,247.619h-4.762V85.714h4.761c7.876,0,14.286-6.41,14.286-14.286V52.381c0-7.876-6.41-14.286-14.286-14.286 h-4.762v-9.524h-9.524v9.524H197.21l-19.048-19.048h-73.4V0H61.905v19.048h-7.143L40.476,38.095H28.571v-9.524h-9.524v9.524 h-4.762C6.41,38.095,0,44.505,0,52.381v19.048c0,7.876,6.41,14.286,14.286,14.286h4.762V247.62h-4.762 C6.41,247.619,0,254.029,0,261.905v19.048c0,7.876,6.41,14.286,14.286,14.286h266.667c7.876,0,14.286-6.41,14.286-14.286v-19.048 C295.239,254.029,288.829,247.619,280.953,247.619z M71.429,9.524h23.81v9.524h-23.81V9.524z M59.524,28.571h2.381h42.857h69.457 l9.524,9.524H52.381L59.524,28.571z M14.286,76.191c-2.629-0.001-4.762-2.139-4.762-4.762V52.381 c0-2.624,2.133-4.762,4.762-4.762h266.667c2.629,0,4.762,2.138,4.762,4.762v19.048c0,2.624-2.133,4.762-4.762,4.762H14.286z  M266.667,85.714v161.905h-9.524V85.714H266.667z M257.143,271.428c0,2.629-2.133,4.762-4.762,4.762 c-2.629,0-4.762-2.133-4.762-4.762c0-2.629,2.133-4.762,4.762-4.762C255.01,266.666,257.143,268.799,257.143,271.428z  M247.619,85.714v161.905h-9.524V85.714H247.619z M228.572,85.714v161.905h-9.524V85.714H228.572z M209.524,85.714v161.905H200 V85.714H209.524z M190.476,85.714v161.905h-9.524V85.714H190.476z M171.429,85.714v161.905h-9.524V85.714H171.429z  M152.381,85.714v161.905h-9.524V85.714H152.381z M133.334,85.714v161.905h-9.524V85.714H133.334z M114.286,85.714v161.905 h-9.524V85.714H114.286z M95.238,85.714v161.905h-9.524V85.714H95.238z M76.191,85.714v161.905h-9.524V85.714H76.191z  M57.143,85.714v161.905h-9.524V85.714H57.143z M38.095,85.714v161.905h-9.524V85.714H38.095z M285.714,280.953 c0,2.629-2.133,4.762-4.762,4.762h-28.571H14.286c-2.629,0-4.762-2.133-4.762-4.762v-19.048c0-2.629,2.133-4.762,4.762-4.762 H252.38c-7.875,0.001-14.285,6.41-14.285,14.286c0,7.876,6.41,14.286,14.286,14.286c7.876,0,14.286-6.41,14.286-14.286 c0-7.876-6.409-14.285-14.285-14.286h28.57c2.629,0,4.762,2.133,4.762,4.762V280.953z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.857,
    y: 57.143,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 57.143,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.905,
    y: 57.143,
    width: 9.524,
    height: 9.524
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.905,
    y: 57.143,
    width: 9.524,
    height: 9.524
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.598d716bfe720ca62d55659647fc6027.svg";
export { ForwardRef as ReactComponent };